export const industries = [
  {
    slug: 'healthcare',
    icon: 'ri-heart-pulse-line',
    title: 'Healthcare',
    desc: 'HIPAA-compliant healthcare solutions including telemedicine platforms, EHR systems, patient portals, and AI diagnostics. We help healthcare providers deliver better patient outcomes through technology.',
    stats: [
      { value: '50+', label: 'Healthcare Projects' },
      { value: '4.8/5', label: 'Client Rating' },
    ],
    highlights: ['Telemedicine Platform', 'EHR Integration', 'AI Diagnostics', 'Patient Portals', 'HIPAA Compliance'],
    caseStudies: [
      { title: 'MediCare+ Patient Platform', desc: 'Telemedicine platform serving 100K+ patients' },
      { title: 'MediTrack EHR System', desc: 'Electronic health record system for 25 hospitals' },
    ],
  },
  {
    slug: 'ecommerce',
    icon: 'ri-shopping-bag-3-line',
    title: 'E-Commerce',
    desc: 'Scalable e-commerce platforms with multi-vendor support, AI-driven recommendations, inventory management, and seamless payment integration. Built to handle millions of transactions.',
    stats: [
      { value: '80+', label: 'E-Commerce Projects' },
      { value: '3x', label: 'Avg. Revenue Growth' },
    ],
    highlights: ['Multi-Vendor Platform', 'AI Recommendations', 'Payment Integration', 'Inventory Sync', 'PWA Support'],
    caseStudies: [
      { title: 'ShopNow Marketplace', desc: '10K+ products, 250ms page loads' },
      { title: 'StyleHub Fashion', desc: 'Premium fashion e-commerce with AR try-on' },
    ],
  },
  {
    slug: 'education',
    icon: 'ri-graduation-cap-line',
    title: 'Education',
    desc: 'EdTech platforms with live virtual classrooms, AI-powered tutoring, gamified learning, and comprehensive LMS solutions. Transforming how students learn and teachers teach.',
    stats: [
      { value: '30+', label: 'EdTech Projects' },
      { value: '50K+', label: 'Students Served' },
    ],
    highlights: ['Virtual Classrooms', 'AI Tutoring', 'Gamified Learning', 'LMS Platform', 'Offline Support'],
    caseStudies: [
      { title: 'EduLearn Mobile Platform', desc: '50K+ students, 92% completion rate' },
      { title: 'SkillUp LMS', desc: 'Corporate training platform for 200+ companies' },
    ],
  },
  {
    slug: 'manufacturing',
    icon: 'ri-settings-3-line',
    title: 'Manufacturing',
    desc: 'Industry 4.0 solutions with IoT integration, predictive maintenance, supply chain optimization, and smart factory dashboards. Driving efficiency through intelligent automation.',
    stats: [
      { value: '25+', label: 'MFG Projects' },
      { value: '30%', label: 'Avg. Cost Reduction' },
    ],
    highlights: ['IoT Integration', 'Predictive Maintenance', 'Supply Chain', 'Quality Control', 'Smart Dashboards'],
    caseStudies: [
      { title: 'AutoLine Smart Factory', desc: 'IoT platform monitoring 500+ machines' },
      { title: 'PrecisionMold ERP', desc: 'Manufacturing ERP for precision engineering' },
    ],
  },
  {
    slug: 'real-estate',
    icon: 'ri-building-2-line',
    title: 'Real Estate',
    desc: 'PropTech solutions including virtual property tours, CRM for real estate agents, property management systems, and AI-powered valuation tools. Modernizing real estate transactions.',
    stats: [
      { value: '20+', label: 'Real Estate Projects' },
      { value: '40%', label: 'Lead Conversion' },
    ],
    highlights: ['Virtual Tours', 'Property CRM', 'AI Valuation', 'Document Management', 'Investor Portals'],
    caseStudies: [
      { title: 'PropView 360', desc: 'Virtual tour platform for 5000+ properties' },
      { title: 'EstateCRM', desc: 'Real estate CRM used by 1000+ agents' },
    ],
  },
  {
    slug: 'logistics',
    icon: 'ri-truck-line',
    title: 'Logistics & Supply Chain',
    desc: 'End-to-end logistics solutions with real-time fleet tracking, route optimization, warehouse automation, and supply chain visibility. From first mile to last mile delivery.',
    stats: [
      { value: '15+', label: 'Logistics Projects' },
      { value: '50%', label: 'Faster Delivery' },
    ],
    highlights: ['Fleet Tracking', 'Route Optimization', 'Warehouse WMS', 'Last-Mile Delivery', 'Supply Chain Analytics'],
    caseStudies: [
      { title: 'LogiChain ERP Suite', desc: 'Fleet management for 2000+ vehicles' },
      { title: 'ShipFast Courier', desc: 'Last-mile delivery optimization platform' },
    ],
  },
  {
    slug: 'fintech',
    icon: 'ri-bank-line',
    title: 'Fintech & Banking',
    desc: 'Secure financial solutions with payment gateways, digital wallets, lending platforms, and regulatory compliance. Built with bank-grade security and real-time processing.',
    stats: [
      { value: '18+', label: 'Fintech Projects' },
      { value: '1M+', label: 'Daily Transactions' },
    ],
    highlights: ['Payment Gateway', 'Digital Wallets', 'Lending Platform', 'KYC/AML Compliance', 'Fraud Detection'],
    caseStudies: [
      { title: 'FinSecure Payment Gateway', desc: '1M+ daily transactions, PCI-DSS certified' },
      { title: 'QuickLoan Platform', desc: 'AI-powered instant lending for SMEs' },
    ],
  },
  {
    slug: 'hospitality',
    icon: 'ri-hotel-line',
    title: 'Hospitality',
    desc: 'Smart hospitality solutions including booking engines, property management systems, guest experience apps, and revenue management tools. Elevating guest satisfaction through technology.',
    stats: [
      { value: '12+', label: 'Hospitality Projects' },
      { value: '4.9/5', label: 'Guest Satisfaction' },
    ],
    highlights: ['Booking Engine', 'PMS Integration', 'Guest Apps', 'Revenue Management', 'Contactless Tech'],
    caseStudies: [
      { title: 'RestaPro Suite', desc: 'Restaurant management platform for chains' },
      { title: 'GuestVibe Hotel App', desc: 'Guest experience app for luxury hotels' },
    ],
  },
];